import { style } from "@vanilla-extract/css";
import { breakpoints, vars } from "../../styles";

export const buttonsWrapper = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.xs,

  "@media": {
    [`screen and (min-width: ${breakpoints[4]})`]: {
      flexDirection: "row",
    },
  },
});
